(() => {
  const config = document.querySelector('[data-gp-klarna-variants]');
  if (!config) return;
  const variants = JSON.parse(config.textContent);
  const wrappers = [...document.querySelectorAll('.gp-klarna-message')];
  const form = document.querySelector('#ProductForm, #CosmeticProductForm');
  if (!wrappers.length || !form) return;
  let lastId, lastPrice;
  const prefixByWrapper = new WeakMap();
  const observed = new WeakSet();
  const number = new Intl.NumberFormat('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
  function reset(wrapper) {
    wrapper.classList.remove('gp-klarna-custom');
    const prefix = prefixByWrapper.get(wrapper);
    if (prefix) { prefix.replaceChildren(); delete prefix.dataset.monthly; }
  }
  function selected() {
    const id = form.querySelector('[name="id"]')?.value;
    return variants.find(v => String(v.id) === id);
  }
  function customize(wrapper) {
    const placement = wrapper.querySelector('klarna-placement');
    const shadow = placement?.shadowRoot;
    if (!shadow) { reset(wrapper); return; }
    if (!observed.has(shadow)) {
      observed.add(shadow);
      new MutationObserver(() => customize(wrapper)).observe(shadow, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class']});
    }
    const message = shadow.querySelector('[part~="osm-message"]');
    const amount = message?.querySelector('strong')?.textContent.trim();
    const variant = selected();
    // Use the provider's actual offer, rather than advertising a plan by price alone.
    const eligible = variant?.available && message &&
      /3\s+pagamenti\s+da/i.test(message.textContent) &&
      /interessi\s+0%/i.test(message.textContent) &&
      Number(placement.dataset.purchaseAmount) === variant.price &&
      message.querySelector('[part~="osm-cta"]') &&
      amount && amount.includes(number.format(Math.floor(variant.price / 3) / 100));
    if (!eligible) { reset(wrapper); return; }
    let prefix = prefixByWrapper.get(wrapper);
    if (!prefix) {
      prefix = document.createElement('span');
      prefix.className = 'gp-klarna-prefix';
      wrapper.prepend(prefix);
      prefixByWrapper.set(wrapper, prefix);
    }
    const monthly = number.format(Math.floor(variant.price / 3) / 100) + ' €/mese';
    if (prefix.dataset.monthly !== monthly) {
      const bold = document.createElement('strong');
      bold.textContent = monthly;
      prefix.replaceChildren(document.createTextNode('Da '), bold, document.createTextNode(' in 3 rate con'));
      prefix.dataset.monthly = monthly;
    }
    wrapper.classList.add('gp-klarna-custom');
  }
  function sync() {
    const variant = selected();
    if (!variant) return;
    wrappers.forEach(w => { w.hidden = !variant.available; });
    if (lastId !== variant.id || lastPrice !== variant.price) {
      wrappers.forEach(reset);
      lastId = variant.id; lastPrice = variant.price;
      if (window.KOSMApp?.updatePurchaseAmount) window.KOSMApp.updatePurchaseAmount(variant.price);
    }
    wrappers.forEach(customize);
  }
  wrappers.forEach(wrapper => new MutationObserver(sync).observe(wrapper, {childList:true, subtree:true}));
  document.addEventListener('change', () => requestAnimationFrame(sync));
  document.addEventListener('variant:change', sync);
  // Some theme/app pickers set input.value without dispatching a change event.
  setInterval(() => { if (!document.hidden) sync(); }, 500);
  sync();
})();
